var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "stamp-preview" }, [
    _c(
      "div",
      { staticClass: "d-flex justify-content-between align-items-center" },
      [
        _c("label", { staticClass: "small font-weight-bold text-muted mb-0" }, [
          _vm._v("Vista previa (arrastre los elementos para posicionarlos)")
        ]),
        _c(
          "span",
          {
            staticClass: "badge badge-light border text-muted ml-2",
            attrs: { title: "Ancho x alto que se está usando" }
          },
          [
            _vm._v(
              " " +
                _vm._s(_vm.logicalWidth) +
                " × " +
                _vm._s(_vm.logicalHeight) +
                " "
            )
          ]
        )
      ]
    ),
    _c(
      "div",
      {
        staticClass:
          "border rounded p-2 bg-white text-center mt-1 canvas-scroll"
      },
      [
        _c("canvas", {
          ref: "canvas",
          style: _vm.canvasStyle,
          attrs: { width: _vm.canvasWidth, height: _vm.canvasHeight },
          on: {
            mousedown: _vm.onMouseDown,
            mousemove: _vm.onMouseMove,
            mouseup: _vm.onMouseUp,
            mouseleave: _vm.onMouseUp
          }
        })
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }